import Transactions from "@/pages/components/Transactions";
import {Box, Card, Stack} from "@mui/material";
import { useEffectOnActive, useKeepAliveContext } from "@hhhgamehhh/keepalive-for-react";
// @ts-ignore
import useMobileDetect from "next-device-detection";
import classes from '../css/index.module.less'
import {getUrlParams} from "@/utils/utils.js";
import RpIcon from "@/components/RpIcon";
import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader";
import {useTranslation} from "react-i18next";

function AssetsTransList() {
  const detectMobile = useMobileDetect();
  const bussinessType = getUrlParams("bussiness_type");
  const navigate = useNavigate()
  const {t} = useTranslation()
  const { refresh, destroy } = useKeepAliveContext();

  return (
    <>
      {
        // detectMobile.isMobile &&
        <Stack direction="column" className={classes["flowList-wrap"]} sx={{padding: '0', flex: 1}}>
          <SimpleHeader
            closeButton={
            <RpIcon icon="arrow-left" clickable
              onClick={() => {
                destroy()
                navigate(-1)
              }} />
            }
            backEnable
            title={t('assets_list')}
          />
          <Stack direction="column" sx={{flex: 1, height: '500px'}}>
            <Transactions bussinessType={''} isCompact={false} pageable scrollCacheEnable />
          </Stack>
        </Stack>
      }
    </>
  );
}

export default AssetsTransList;
